import { MapPin, Train, Plane, GraduationCap, Hospital, ShoppingBag, Navigation } from "lucide-react";

const SITE_COORDS = "23.3589025,76.7222118";
const MAPS_LINK = "https://maps.app.goo.gl/p6Ca7LpS7cJfHEqG9";

const NEARBY = [
  { icon: Train, t: "Shujalpur Railway Station", d: "8 mins drive" },
  { icon: Plane, t: "Indore Airport", d: "1 hr 30 mins" },
  { icon: GraduationCap, t: "Schools & Colleges", d: "Within 4 km radius" },
  { icon: Hospital, t: "Government & Pvt. Hospitals", d: "5 mins drive" },
  { icon: ShoppingBag, t: "Mandi & Market", d: "Walking distance" },
  { icon: MapPin, t: "Bhopal–Indore Highway", d: "Direct connectivity" },
];

export default function Location() {
  return (
    <div className="bg-[#0a0a0b] text-white pt-32">
      <section className="max-w-7xl mx-auto px-6 lg:px-12 py-16" data-testid="location-hero">
        <p className="label-overline">Location</p>
        <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl mt-5 tracking-tight leading-[1.05] max-w-4xl">
          Connected to everywhere, <br /><span className="italic text-[#c5a059]">grounded in Shujalpur</span>.
        </h1>
        <p className="text-[#cfcfd2] mt-8 max-w-2xl leading-relaxed">
          Strategically positioned along the Bhopal–Indore highway corridor, Shujalpur
          offers the rare combination of small-town tranquillity and metropolitan accessibility.
        </p>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-12 pb-16">
        <div className="grid lg:grid-cols-12 gap-6">
          <div className="lg:col-span-7 rounded-xl overflow-hidden border border-[#2a2a2d] aspect-[16/10] lg:aspect-auto relative">
            <iframe
              title="Shree Aryavarta Developers — Site Location"
              src={`https://www.google.com/maps?q=${SITE_COORDS}&z=15&output=embed`}
              className="w-full h-full min-h-[400px] grayscale contrast-125"
              loading="lazy"
              data-testid="location-map"
            />
            <a
              href={MAPS_LINK}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="location-directions-btn"
              className="absolute bottom-4 right-4 btn-gold inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-xs font-medium"
            >
              <Navigation size={14} /> Get Directions
            </a>
          </div>
          <div className="lg:col-span-5 bg-[#0f0f11] border border-[#2a2a2d] rounded-xl p-8 lg:p-10">
            <p className="label-overline">Nearby</p>
            <h2 className="font-serif text-3xl mt-4">Everything within reach.</h2>
            <ul className="mt-8 space-y-5">
              {NEARBY.map(({ icon: Icon, t, d }) => (
                <li key={t} className="flex items-start gap-4 pb-5 border-b border-[#1f1f22] last:border-b-0">
                  <span className="inline-flex h-10 w-10 rounded-full border border-[#c5a059]/40 items-center justify-center text-[#c5a059] flex-shrink-0">
                    <Icon size={16} strokeWidth={1.4} />
                  </span>
                  <div>
                    <p className="text-white text-sm">{t}</p>
                    <p className="text-xs text-[#8f8f94] mt-1">{d}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      <section className="bg-[#08080a] border-t border-[#1f1f22] py-24">
        <div className="max-w-5xl mx-auto px-6 lg:px-12 text-center">
          <p className="label-overline">Why Shujalpur</p>
          <h2 className="font-serif text-4xl md:text-5xl mt-4 tracking-tight">A growth corridor in the making.</h2>
          <p className="text-[#cfcfd2] mt-6 leading-relaxed">
            With improved highway connectivity, an expanding agricultural mandi, and emerging
            industrial activity, Shujalpur is rapidly transitioning from a heritage town to a
            promising real-estate destination — making today's plot value tomorrow's family asset.
          </p>
        </div>
      </section>
    </div>
  );
}
